<template lang="pug">
  div.sources-waste.source-update
    e-form-modal(
    ref="modalForm"
    @submitModalForm="sendForm()"
    :hideDeleteButton="false"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title
          template(v-if="fields && fields.id") {{fields.name}}
          template(v-else) Добавление новой записи
        div.tabs
          span(@click="tabView = 'tab1'" :class="activeClass('tab1')") Общие сведения
      slot
        e-form(:formValidator="formValidator")
          // вкладка ОБЩИЕ СВЕДЕНИЯ
          div(v-show="tabView == 'tab1'")
            div.body
              div.col
                // src/components/input/input.vue
                e-form-group(
                name="name"
                :model="fields"
                tabView="tab1"
                label="Наименование"
                )

                // src/components/select/select.vue
                e-form-group(
                name="extend_from"
                :model="fields"
                tabView="tab1"
                label="Наследовать от"
                inputType="select"
                :options="extendFromOptions"
                )

                // src/components/input/calendar.vue
                e-form-group(
                name="started_at"
                :model="fields"
                tabView="tab1"
                label="Дата начала действия"
                inputType="calendar"
                )

                // src/components/input/checkbox.vue
                e-form-group(
                name="emulateWrongValidation"
                :model="fields"
                tabView="tab1"
                label="Эмулировать неверную валидацию после нажатия на сохран"
                inputType="checkbox"
                )

              div.col
                // now in src/components/select/select-nested-list.vue
                .checkbox-tree
                  .checkbox-tree__item
                    .checkbox-tree__item-container
                      .checkbox-tree__arrow
                      label.checkbox-label
                        input(type="checkbox").checkbox-input
                        .checkbox-icon
                        .checkbox-text
                          | Все зоны 1
                  .checkbox-tree__item.checkbox-tree__item_open
                    .checkbox-tree__item-container
                      .checkbox-tree__arrow
                      label.checkbox-label
                        input(type="checkbox").checkbox-input
                        .checkbox-icon
                        .checkbox-text
                          | Все зоны 2
                    .checkbox-tree__item.checkbox-tree__item_open
                      .checkbox-tree__item-container
                        .checkbox-tree__arrow
                        label.checkbox-label
                          input(type="checkbox").checkbox-input
                          .checkbox-icon.checkbox-icon_group
                          .checkbox-text
                            | Все зоны 3
                      .checkbox-tree__item
                        .checkbox-tree__item-container
                          label.checkbox-label
                            input(type="checkbox").checkbox-input
                            .checkbox-icon
                            .checkbox-text
                              | Все зоны 4
                      .checkbox-tree__item
                        .checkbox-tree__item-container
                          .checkbox-tree__arrow
                          label.checkbox-label
                            input(type="checkbox").checkbox-input
                            .checkbox-icon
                            .checkbox-text
                              | Все зоны 5

              div.col
</template>

<script>
  import formBaseMixin from '../../form/form-base-mixin'

  export default {
    mixins: [formBaseMixin],
    data () {
      return {
        tabView: 'tab1',
        fields: {
          name: 'Sample title',
          extend_from: '',
          started_at: '',
          emulateWrongValidation: false,
          zones: []
        }
      }
    },
    computed: {
      extendFromOptions () {
        return [
          {id: 1, name: 'foo'},
          {id: 2, name: 'bar'}
        ]
      }
    },
    methods: {
      additionalValidate: async function (hasError = false, errors = {}) {
        if (this.fields.emulateWrongValidation) {
          for (let fieldName in this.fields) {
            errors[fieldName] = 'Ошибка валидации'
          }
          this.formValidator.handleServerErrors({data: {errors}})
          return Promise.reject(false)
        }
        return Promise.resolve(true)
      },
      getUpdateOrCreateUrl () {
        return null
      },
      getItemEndpoint () {
        return null
      }
    }
  }
</script>
